import React from 'react'
import LiveTemplateDefault from 'src/components/template/live/canada'
import { canadaPlanData } from 'src/constants/planData/canadaPlanData'
export default (props) => (
  <LiveTemplateDefault
    location={props.location}
    lang="en"
    market="canada"
    callsign="MLBHD"
    title="Get MLB.TV with Fubo"
    subtitle="Watch +2000 live games and much more"
    customNetworks={['mlbtv', 'mlbnetwork']}
    networkName="MLB Network"
    highlightImage="https://assets-imgx.fubo.tv/marketing/lp/images/devices/mlb-tv-phone.png?ch=width&auto=format,compress"
    highlightHeadline="Get MLB.TV with Fubo"
    highlightSubtitle="See every out-of-market MLB team in action in over 2,000 live games this season. Watch them all live from your TV, phone & other devices."
    networkSubtitle="Watch Premier League, Serie A, MLB & so much more?"
    networkSet="canadaEssentials"
    plansSubtitle="Canada’s home to streaming live sports and top entertainment"
    league="mlb"
    forceAnchorLink={true}
    planCardsConfig={{
      plans: [canadaPlanData.mlbtv_offer],
    }}
  />
)
